import { render } from "./AdminSitesPage.vue?vue&type=template&id=cd42153a"
import script from "./AdminSitesPage.vue?vue&type=script&lang=js"
export * from "./AdminSitesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__